import { BoardPurchaseCreatableInterface } from '../interfaces/board-purchase-creatable.interface';
import { BoardPurchaseDto } from './board-purchase.dto';
import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { MaterialCascadeDto } from '../../material/dto/material-cascade.dto';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsUUID, Validate, ValidateNested } from 'class-validator';
import { MaterialUniqueValidator } from '../../material/validators/material-unique.validator';
import { BoardPurchaseFloorCascadeDto } from '../../board-purchase-floor/dto/board-purchase-floor-cascade.dto';
import { MaterialAllowZeroAmountValidator } from '../../material/validators/material-allow-zero-value.validator';

export class BoardPurchaseCreateDto
  extends IntersectionType(
    PickType(BoardPurchaseDto, [
      'orderNumber',
      'dateExpected',
      'supplierId',
      'jobId',
    ]),
    PartialType(
      PickType(BoardPurchaseDto, [
        'laborOnly',
        'isReplacement',
        'approved',
        'approvedGeo',
        'notesForSupplier',
      ]),
    ),
  )
  implements BoardPurchaseCreatableInterface
{
  @ApiPropertyOptional({
    type: () => [BoardPurchaseFloorCascadeDto],
    title: 'Associated Board Floors',
    description: 'The board floors associated with this purchase',
  })
  @Expose()
  @Type(() => BoardPurchaseFloorCascadeDto)
  @ValidateNested({ each: true })
  boardPurchaseFloors?: BoardPurchaseFloorCascadeDto[];

  @ApiPropertyOptional({
    type: () => [MaterialCascadeDto],
    title: 'Associated Materials',
    description: 'The materials associated with this purchase',
  })
  @Expose()
  @Type(() => MaterialCascadeDto)
  @Validate(MaterialUniqueValidator)
  @Validate(MaterialAllowZeroAmountValidator)
  @ValidateNested({ each: true })
  materials?: MaterialCascadeDto[];

  @ApiPropertyOptional({
    type: 'boolean',
    description: 'Create model boards as default?',
  })
  @Expose()
  @IsBoolean()
  createModelDefaults?: boolean;

  @ApiPropertyOptional({
    format: 'uuid',
    title: 'Job Phase ID',
    description: 'The ID of the job phase',
  })
  @Expose()
  @IsUUID()
  jobPhaseId?: string;
}
